import React from 'react';
import withIcon from '../utilities/withIcon';

const IconFlask = () => {
  return (
    <g>
      <path d="M11.29 0a.71.71 0 0 1 0 1.418h-.79v3.126a6.001 6.001 0 1 1-5 0V1.418h-.79A.71.71 0 0 1 4.71 0h6.58zM9 1.418H7v4.044a.2.2 0 0 1-.143.191c-.368.111-.643.21-.823.298a4.519 4.519 0 0 0-2.066 2.05L6.25 8a.75.75 0 0 1 0 1.5H3.527a4.55 4.55 0 0 0 0 1H6.25a.75.75 0 1 1 0 1.5l-2.282.001a4.5 4.5 0 1 0 6.048-6.025 5.915 5.915 0 0 0-.873-.322A.2.2 0 0 1 9 5.463L9 1.418z" />
    </g>
  );
};

export default withIcon(IconFlask);
